import { PropsWithChildren } from 'react'

import { tv, type VariantProps } from 'tailwind-variants'

import type { Tailwind as TailwindTypes } from '@/tailwind-types'
import { cn } from '@/utils'

export const labelVariants = tv({
  base: 'font-body leading-default text-surface-black-50',
  variants: {
    italic: {
      true: 'italic',
      false: ''
    },
    size: {
      'body-xl': 'text-body-xl',
      'body-lg': 'text-body-lg',
      'body-md': 'text-body-md',
      'caption-md': 'text-caption-lg',
      'caption-sm': 'text-caption-sm'
    },
    weight: {
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
      extraBold: 'font-extrabold'
    }
  },
  defaultVariants: {
    size: 'caption-sm',
    weight: 'bold'
  }
})

export type TLabelProps = PropsWithChildren &
  Pick<React.LabelHTMLAttributes<HTMLLabelElement>, 'htmlFor'> &
  VariantProps<typeof labelVariants> & {
    color?: TailwindTypes['color']
    margin?: TailwindTypes['margin']
    padding?: TailwindTypes['padding']
    textTransform?: TailwindTypes['textTransform']
  }

/**
 * @deprecated Use `Label` from `@alternative/acqua/atoms` instead. The acqua-ui Label is being phased out in favor of the acqua design system.
 */
export const Label = ({
  children,
  color,
  italic,
  margin,
  padding,
  size,
  textTransform,
  weight,
  ...restProps
}: TLabelProps): JSX.Element => (
  <label
    className={cn(
      labelVariants({
        italic,
        size,
        weight
      }),
      color,
      margin,
      padding,
      textTransform
    )}
    {...restProps}
  >
    {children}
  </label>
)
